import React from 'react';
import { Switch } from 'react-router-dom';

// tslint:disable-next-line:no-unused-variable
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import BankingUser from './banking-user';
import BankingUserProfile from './banking-user-profile';
import IbftBanks from './ibft-banks';
import IpCapture from './ip-capture';
import OtpSms from './otp-sms';
import BillingCategory from './billing-category';
import Institutes from './institutes';
import Beneficiaries from './beneficiaries';
import ScheduledPayments from './scheduled-payments';
import ScheduledPaymentAttempts from './scheduled-payment-attempts';
import PasswordHistory from './password-history';
import ServiceCategory from './service-category';
import ServiceCompanies from './service-companies';
import NotificationTemplate from './notification-template';
import SecurityQuestion from './security-question';
import SecurityAnswer from './security-answer';
/* jhipster-needle-add-route-import - JHipster will add routes here */

const Routes = ({ match }) => (
  <div>
    <Switch>
      {/* prettier-ignore */}
      <ErrorBoundaryRoute path={`${match.url}/banking-user`} component={BankingUser} />
      <ErrorBoundaryRoute path={`${match.url}/banking-user-profile`} component={BankingUserProfile} />
      <ErrorBoundaryRoute path={`${match.url}/ibft-banks`} component={IbftBanks} />
      <ErrorBoundaryRoute path={`${match.url}/ip-capture`} component={IpCapture} />
      <ErrorBoundaryRoute path={`${match.url}/otp-sms`} component={OtpSms} />
      <ErrorBoundaryRoute path={`${match.url}/billing-category`} component={BillingCategory} />
      <ErrorBoundaryRoute path={`${match.url}/institutes`} component={Institutes} />
      <ErrorBoundaryRoute path={`${match.url}/beneficiaries`} component={Beneficiaries} />
      <ErrorBoundaryRoute path={`${match.url}/scheduled-payments`} component={ScheduledPayments} />
      <ErrorBoundaryRoute path={`${match.url}/scheduled-payment-attempts`} component={ScheduledPaymentAttempts} />
      <ErrorBoundaryRoute path={`${match.url}/password-history`} component={PasswordHistory} />
      <ErrorBoundaryRoute path={`${match.url}/service-category`} component={ServiceCategory} />
      <ErrorBoundaryRoute path={`${match.url}/service-companies`} component={ServiceCompanies} />
      <ErrorBoundaryRoute path={`${match.url}/notification-template`} component={NotificationTemplate} />
      <ErrorBoundaryRoute path={`${match.url}/security-question`} component={SecurityQuestion} />
      <ErrorBoundaryRoute path={`${match.url}/security-answer`} component={SecurityAnswer} />
      {/* jhipster-needle-add-route-path - JHipster will add routes here */}
    </Switch>
  </div>
);

export default Routes;
